import { Link } from "react-router-dom";

export default function AboutUsPage() {
  return (
    <>
      <Hero />
      <Video />
      <ExampleEnvolvements />
      <FAQ />
      <Team />
    </>
  );
}

function Hero() {
  return (
    <section className="py-3 dark:bg-primary-400 dark:text-gray-900">
      <div className="container mx-auto flex flex-col items-center justify-center p-4 space-y-8 md:p-10">
        <h1 className="text-5xl font-bold leading-none text-center">
          Something totally different
        </h1>
        <p className="pt-2 pb-8 text-xl font-medium text-center">
          Envolvly - a platform to build intimate connections between creators
          and consumers.<br></br>
          Envolvly provides the opportunity for creators to develop an intimate
          relationship with their audience by directly engaging them within the
          content-creation process, and forming unique ways of building tighter
          communities. Our platform hosts a wide array of tools for creators to
          create envolvments for their viewers, which grants them the chance to
          become part of upcoming content—whether it be through monetary
          support, or fully active contribution.
        </p>
      </div>
    </section>
  );
}

function Video() {
  return (
    <section className="py-3 dark:bg-gray-800 dark:text-gray-100">
      <div className="container mx-auto flex flex-col items-center justify-center p-4 space-y-8 md:p-10">
        <h1 className="text-4xl font-bold leading-none text-center sm:text-5xl">
          What is Envolvly?
        </h1>
        <div className="w-[1200px] max-w-full aspect-video rounded-lg shadow-xl overflow-hidden">
          <iframe
            src="https://www.youtube.com/embed/yDuAXjCEArw"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="w-full h-full"
          ></iframe>
        </div>
      </div>
    </section>
  );
}

function ExampleEnvolvements() {
  return (
    <section className="py-3 dark:bg-primary-400 dark:text-gray-900">
      <div className="container mx-auto flex flex-col items-center justify-center p-4 space-y-8 md:p-10">
        <h1 className="text-4xl font-bold leading-none text-center sm:text-5xl">
          Example Envolvements
        </h1>
        <ul className="list-disc list-inside pt-2 pb-8 text-xl font-medium text-center">
          <li>A musician asking their fans to submit lyrics for a new song.</li>
          <li>
            A chef sharing a recipe and asking their followers to cook it and
            share their results.
          </li>
          <li>
            A streamer challenging their viewers to a game and featuring the
            winner in their next stream.
          </li>
          <li>
            A podcaster asking their listeners to submit questions for an
            upcoming Q&A episode.
          </li>
        </ul>
        <Link to="/explore">
          <button className="px-8 py-3 text-lg font-semibold rounded dark:bg-gray-800 dark:text-gray-50 border-2 border-green-500">
            Find More
          </button>
        </Link>
      </div>
    </section>
  );
}

function FAQ() {
  return (
    <section className="py-3 dark:bg-gray-800 dark:text-gray-100">
      <div className="container flex flex-col items-center justify-center p-4 mx-auto sm:p-10">
        <h1 className="text-4xl font-bold leading-none text-center sm:text-5xl">
          Frequently Asked Questions
        </h1>
        <div className="pt-2 pb-8 text-xl font-medium text-center">
          <div className="mb-4">
            <h2 className="text-2xl font-semibold">What is Envolvly?</h2>
            <p>
              Envolvly is a platform that connects creators with their fans in a
              more intimate and collaborative way. Creators can launch
              "envolvements" to engage their audience in the content creation
              process.
            </p>
          </div>
          <div className="mb-4">
            <h2 className="text-2xl font-semibold">
              How do I get started as a creator?
            </h2>
            <p>
              Currently, we are in a closed beta. You can apply to be a creator
              through our ambassador program.
            </p>
          </div>
          <div>
            <h2 className="text-2xl font-semibold">
              How do I participate in an envolvement?
            </h2>
            <p>
              You can browse active envolvements on our explore page. Each
              envolvement will have its own set of rules and requirements for
              participation.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

function Team() {
  return (
    <section className="py-3 dark:bg-gray-800 dark:text-gray-100">
      <div className="container flex flex-col items-center justify-center p-4 mx-auto sm:p-10">
        <p className="p-2 text-sm font-medium tracking-wider text-center uppercase">
          Our team
        </p>
        <h1 className="text-4xl font-bold leading-none text-center sm:text-5xl">
          The talented people behind the scenes
        </h1>
        <div className="flex flex-row flex-wrap-reverse justify-center mt-8">
          <div className="flex flex-col justify-center w-full px-8 mx-6 my-12 text-center rounded-md md:w-96 lg:w-80 xl:w-64 dark:bg-gray-100 dark:text-gray-800">
            <img
              alt=""
              className="self-center flex-shrink-0 w-24 h-24 -mt-12 bg-center bg-cover rounded-full dark:bg-gray-500"
              src="https://j-m-s.dev/_next/static/media/beaver-headshot.993076ea.jpg"
            />
            <div className="flex-1 my-4">
              <p className="text-xl font-semibold leading-snug">James Smith</p>
              <p>Co-Founder & Technical Lead</p>
            </div>
            <div className="flex items-center justify-center p-3 space-x-3 border-t-2">
              <a
                rel="noopener noreferrer"
                href="mailto:james@envolvly.com"
                title="Email"
                className="dark:text-gray-900 hover:dark:text-violet-400"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="w-5 h-5"
                >
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
                </svg>
              </a>
              <a
                rel="noopener noreferrer"
                href="https://j-m-s.dev/"
                title="Website"
                className="dark:text-gray-900 hover:dark:text-violet-400"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  className="feather feather-globe w-5 h-5"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="2" y1="12" x2="22" y2="12"></line>
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                </svg>
              </a>
              <a
                rel="noopener noreferrer"
                href="https://www.linkedin.com/in/james-m-smith-1/"
                title="LinkedIn"
                className="dark:text-gray-900 hover:dark:text-violet-400"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 32 32"
                  className="w-5 h-5"
                >
                  <path d="M8.268 28h-5.805v-18.694h5.805zM5.362 6.756c-1.856 0-3.362-1.538-3.362-3.394s1.505-3.362 3.362-3.362 3.362 1.505 3.362 3.362c0 1.856-1.506 3.394-3.362 3.394zM29.994 28h-5.792v-9.1c0-2.169-0.044-4.95-3.018-4.95-3.018 0-3.481 2.356-3.481 4.794v9.256h-5.799v-18.694h5.567v2.55h0.081c0.775-1.469 2.668-3.019 5.492-3.019 5.875 0 6.955 3.869 6.955 8.894v10.269z"></path>
                </svg>
              </a>
              <a
                rel="noopener noreferrer"
                href="https://www.github.com/gitJamoo"
                title="GitHub"
                className="dark:text-gray-900 hover:dark:text-violet-400"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 32 32"
                  className="w-5 h-5"
                >
                  <path d="M16 0.396c-8.839 0-16 7.167-16 16 0 7.073 4.584 13.068 10.937 15.183 0.803 0.151 1.093-0.344 1.093-0.772 0-0.38-0.009-1.385-0.015-2.719-4.453 0.964-5.391-2.151-5.391-2.151-0.729-1.844-1.781-2.339-1.781-2.339-1.448-0.989 0.115-0.968 0.115-0.968 1.604 0.109 2.448 1.645 2.448 1.645 1.427 2.448 3.744 1.74 4.661 1.328 0.14-1.031 0.557-1.74 1.011-2.135-3.552-0.401-7.287-1.776-7.287-7.907 0-1.751 0.62-3.177 1.645-4.297-0.177-0.401-0.719-2.031 0.141-4.235 0 0 1.339-0.427 4.4 1.641 1.281-0.355 2.641-0.532 4-0.541 1.36 0.009 2.719 0.187 4 0.541 3.043-2.068 4.381-1.641 4.381-1.641 0.859 2.204 0.317 3.833 0.161 4.235 1.015 1.12 1.635 2.547 1.635 4.297 0 6.145-3.74 7.5-7.296 7.891 0.556 0.479 1.077 1.464 1.077 2.959 0 2.14-0.020 3.864-0.020 4.385 0 0.416 0.28 0.916 1.104 0.755 6.4-2.093 10.979-8.093 10.979-15.156 0-8.833-7.161-16-16-16z"></path>
                </svg>
              </a>
            </div>
          </div>
          <div className="flex flex-col justify-center w-full px-8 mx-6 my-12 text-center rounded-md md:w-96 lg:w-80 xl:w-64 dark:bg-gray-100 dark:text-gray-800">
            <img
              alt=""
              className="self-center flex-shrink-0 w-24 h-24 -mt-12 bg-center bg-cover rounded-full dark:bg-gray-500"
              src="https://i.imgur.com/eOBGD58.jpeg"
            />
            <div className="flex-1 my-4">
              <p className="text-xl font-semibold leading-snug">John Ireland</p>
              <p>Co-Founder & Business Lead</p>
            </div>
            <div className="flex items-center justify-center p-3 space-x-3 border-t-2">
              <a
                rel="noopener noreferrer"
                href="mailto:john@envolvly.com"
                title="Email"
                className="dark:text-gray-900 hover:dark:text-violet-400"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="w-5 h-5"
                >
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
                </svg>
              </a>
              <a
                rel="noopener noreferrer"
                href="https://www.linkedin.com/in/john-ireland-770095256/"
                title="LinkedIn"
                className="dark:text-gray-900 hover:dark:text-violet-400"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 32 32"
                  className="w-5 h-5"
                >
                  <path d="M8.268 28h-5.805v-18.694h5.805zM5.362 6.756c-1.856 0-3.362-1.538-3.362-3.394s1.505-3.362 3.362-3.362 3.362 1.505 3.362 3.362c0 1.856-1.506 3.394-3.362 3.394zM29.994 28h-5.792v-9.1c0-2.169-0.044-4.95-3.018-4.95-3.018 0-3.481 2.356-3.481 4.794v9.256h-5.799v-18.694h5.567v2.55h0.081c0.775-1.469 2.668-3.019 5.492-3.019 5.875 0 6.955 3.869 6.955 8.894v10.269z"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
